<template>
  <footer class="footer">
    <div class="container-fluid">
      
            
              <div class="small text-muted pull-left">
              e: {{env}} |
              g: {{graphql}} |
              s: {{server}} <br />
              r: {{report}} |
              l: {{lms}}
</div>
            
          
      <div class="copyright pull-right">
        &copy; Coded with
        <i class="fa fa-heart heart"></i> by
        <a href="https://www.tefl.org/" target="_blank">TEFL Org</a>.
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    data(){
      return{
        env:'',
        graphql:'',
        server:'',
        report:'',
        lms:''
       // env:process.env.NODE_ENV
      }
    },
    mounted(){
      this.env=process.env.NODE_ENV;
      this.graphql=process.env.HASURA_URL;
      this.server=process.env.SERVER_URL;
      this.report=process.env.REPORT_URL;
      this.lms=process.env.LMS_URL

    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/ContentFooter.vue